export default (
  <svg width="119" height="36" viewBox="0 0 119 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Google Play</title>
    <path
      d="M113.75.196H4.375C1.959.196 0 2.166 0 4.596v26.397c0 2.43 1.959 4.4 4.375 4.4H113.75c2.416 0 4.375-1.97 4.375-4.4V4.596c0-2.43-1.959-4.4-4.375-4.4Z"
      fill="#000"
    />
    <path
      d="M113.75.9a3.674 3.674 0 0 1 2.596 1.085 3.712 3.712 0 0 1 1.079 2.61v26.398a3.712 3.712 0 0 1-1.079 2.61 3.674 3.674 0 0 1-2.596 1.085H4.375c-.975 0-1.91-.39-2.599-1.082A3.706 3.706 0 0 1 .7 30.993V4.596c0-.98.387-1.92 1.076-2.614A3.665 3.665 0 0 1 4.375.9H113.75Zm0-.704H4.375c-1.16 0-2.273.464-3.094 1.289A4.412 4.412 0 0 0 0 4.595v26.398c0 1.166.46 2.285 1.281 3.11a4.363 4.363 0 0 0 3.094 1.29H113.75c1.16 0 2.273-.464 3.094-1.29a4.414 4.414 0 0 0 1.281-3.11V4.596a4.414 4.414 0 0 0-1.281-3.111A4.365 4.365 0 0 0 113.75.196Z"
      fill="#A6A6A6"
    />
    <path
      d="M41.448 9.215a2.397 2.397 0 0 1-.648 1.76 2.553 2.553 0 0 1-1.933.774c-.727 0-1.423-.29-1.937-.807a2.762 2.762 0 0 1 0-3.895 2.731 2.731 0 0 1 1.937-.806 2.69 2.69 0 0 1 1.085.22c.314.128.593.33.813.59l-.455.465a1.75 1.75 0 0 0-1.443-.633c-.557 0-1.091.222-1.485.618a2.118 2.118 0 0 0 0 2.987c.394.396.928.619 1.485.619a2.02 2.02 0 0 0 1.47-.59 1.65 1.65 0 0 0 .437-1.074h-1.872V8.81h2.546c.013.135.013.27 0 .405ZM45.518 7.006h-2.39v1.672h2.153v.634H43.13v1.663h2.389v.65h-3.063V6.347h3.063v.66ZM48.363 11.636h-.674V7.007h-1.461v-.65h3.605v.65h-1.47v4.629ZM52.44 11.636v-5.28h.673v5.28h-.673ZM56.105 11.636h-.656V7.007h-1.48v-.65h3.606v.65h-1.47v4.629ZM64.4 10.973a2.72 2.72 0 0 1-1.925.803 2.707 2.707 0 0 1-1.925-.803 2.86 2.86 0 0 1 0-3.906 2.722 2.722 0 0 1 1.925-.803 2.708 2.708 0 0 1 2.511 1.7c.134.336.2.695.193 1.056a2.655 2.655 0 0 1-.779 1.953Zm-3.35-.44a1.942 1.942 0 0 0 1.425.599 1.907 1.907 0 0 0 1.427-.599 2.242 2.242 0 0 0 0-3.026 1.916 1.916 0 0 0-1.453-.625 1.933 1.933 0 0 0-1.4.572 2.268 2.268 0 0 0 0 3.027v.052ZM66.126 11.636v-5.28h.823l2.546 4.11V6.355h.683v5.28h-.727l-2.624-4.303v4.293l-.7.01Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth=".2"
      strokeMiterlimit="10"
    />
    <path
      d="M59.614 19.335a3.713 3.713 0 0 0-2.076.624 3.744 3.744 0 0 0-1.38 1.68 3.767 3.767 0 0 0 .8 4.092 3.707 3.707 0 0 0 4.067.815A3.732 3.732 0 0 0 62.7 25.16c.41-.618.627-1.344.626-2.086a3.705 3.705 0 0 0-1.07-2.657 3.665 3.665 0 0 0-2.64-1.083Zm0 6.01a2.247 2.247 0 0 1-1.294-.303 2.281 2.281 0 0 1-.516-3.508 2.255 2.255 0 0 1 2.477-.568 2.26 2.26 0 0 1 1.04.832c.255.376.392.821.394 1.277a2.177 2.177 0 0 1-.574 1.58 2.154 2.154 0 0 1-1.526.69Zm-8.146-6.01a3.713 3.713 0 0 0-2.07.637c-.611.413-1.088 1-1.368 1.685a3.768 3.768 0 0 0 .817 4.083 3.709 3.709 0 0 0 4.064.803 3.732 3.732 0 0 0 1.67-1.384 3.763 3.763 0 0 0 .623-2.084 3.703 3.703 0 0 0-1.079-2.667 3.664 3.664 0 0 0-2.657-1.073Zm0 6.01a2.248 2.248 0 0 1-1.294-.303 2.281 2.281 0 0 1-.516-3.508 2.255 2.255 0 0 1 2.476-.568 2.26 2.26 0 0 1 1.04.832c.256.376.393.821.394 1.277a2.175 2.175 0 0 1-.574 1.58 2.153 2.153 0 0 1-1.526.69Zm-9.695-4.857v1.584h3.78a3.282 3.282 0 0 1-.875 1.997 3.84 3.84 0 0 1-2.913 1.161 4.188 4.188 0 0 1-2.97-1.237 4.236 4.236 0 0 1-1.23-2.986c0-1.12.442-2.195 1.23-2.987a4.188 4.188 0 0 1 2.97-1.237 4.021 4.021 0 0 1 2.843 1.135l1.12-1.117a5.518 5.518 0 0 0-3.964-1.601 5.753 5.753 0 0 0-4.234 1.62 5.844 5.844 0 0 0 0 8.384 5.779 5.779 0 0 0 4.234 1.619 5.293 5.293 0 0 0 4.06-1.628 5.296 5.296 0 0 0 1.366-3.722c.004-.33-.025-.66-.088-.985h-5.329ZM81.42 21.72a3.518 3.518 0 0 0-1.237-1.7 3.487 3.487 0 0 0-1.983-.685 3.484 3.484 0 0 0-2.555 1.107 3.523 3.523 0 0 0-.945 2.633 3.688 3.688 0 0 0 1.069 2.665 3.647 3.647 0 0 0 2.65 1.074 3.683 3.683 0 0 0 1.758-.439 3.709 3.709 0 0 0 1.34-1.224l-1.269-.88a2.114 2.114 0 0 1-1.829 1.03 1.882 1.882 0 0 1-1.078-.282 1.897 1.897 0 0 1-.733-.845l4.979-2.067-.166-.387Zm-5.075 1.249a2.061 2.061 0 0 1 .513-1.507 2.038 2.038 0 0 1 1.43-.684 1.447 1.447 0 0 1 1.382.8l-3.325 1.391Zm-4.05 3.625h1.636V15.595h-1.637v11Zm-2.678-6.423h-.053a2.624 2.624 0 0 0-1.96-.88 3.718 3.718 0 0 0-2.518 1.159 3.76 3.76 0 0 0 0 5.17 3.719 3.719 0 0 0 2.518 1.159 2.524 2.524 0 0 0 1.96-.88h.053v.537c0 1.434-.761 2.2-1.987 2.2a2.048 2.048 0 0 1-1.137-.378 2.066 2.066 0 0 1-.735-.951l-1.426.59c.268.657.725 1.22 1.313 1.614.587.395 1.279.605 1.985.603 1.917 0 3.5-1.135 3.5-3.898v-6.652h-1.513v.607Zm-1.873 5.174a2.252 2.252 0 0 1-1.504-.712 2.276 2.276 0 0 1 0-3.108 2.252 2.252 0 0 1 1.504-.712 2.272 2.272 0 0 1 1.402.764 2.296 2.296 0 0 1 0 3.004c-.36.416-.858.687-1.402.764Zm21.333-9.75H85.2v11h1.636v-4.18h2.275a3.386 3.386 0 0 0 2.563-.909 3.423 3.423 0 0 0 1.084-2.505 3.44 3.44 0 0 0-1.084-2.506 3.401 3.401 0 0 0-2.563-.908l-.035.008Zm0 5.28h-2.319v-3.74h2.319c.496 0 .973.199 1.324.552a1.888 1.888 0 0 1 0 2.663 1.868 1.868 0 0 1-1.324.551v-.026ZM99.2 19.317a3.05 3.05 0 0 0-1.707.403 3.073 3.073 0 0 0-1.207 1.278l1.452.607a1.545 1.545 0 0 1 1.488-.8 1.568 1.568 0 0 1 1.568.819c.099.185.161.388.182.597v.106a3.67 3.67 0 0 0-1.706-.423c-1.567 0-3.15.88-3.15 2.482a2.555 2.555 0 0 0 .847 1.786 2.526 2.526 0 0 0 1.865.633 2.292 2.292 0 0 0 2.083-1.082h.035v.88h1.575v-4.241c.008-1.953-1.444-3.045-3.325-3.045Zm-.193 6.028c-.543 0-1.286-.273-1.286-.933 0-.88.927-1.18 1.75-1.18a2.926 2.926 0 0 1 1.496.37 2.002 2.002 0 0 1-.651 1.239c-.359.32-.82.5-1.3.504h-.009Zm9.258-5.79-1.873 4.769h-.061l-1.881-4.769h-1.75l2.905 6.67-1.654 3.704h1.697l4.489-10.374h-1.872Zm-14.71 7.04h1.637v-11h-1.636v11Z"
      fill="#fff"
    />
    <path
      d="M9.123 6.83c-.285.345-.429.786-.402 1.233v19.463c-.027.448.117.888.402 1.232l.062.07 10.84-10.901v-.264L9.186 6.769l-.062.062Z"
      fill="url(#a)"
    />
    <path
      d="m23.643 21.535-3.614-3.608v-.264l3.614-3.634.087.053 4.28 2.446c1.224.696 1.224 1.84 0 2.543l-4.28 2.464h-.087Z"
      fill="url(#b)"
    />
    <path
      d="m23.73 21.533-3.701-3.713L9.126 28.757a1.422 1.422 0 0 0 1.82.061l12.784-7.285Z"
      fill="url(#c)"
    />
    <path
      d="M23.73 14.079 10.946 6.776a1.413 1.413 0 0 0-1.82.052l10.903 10.964 3.7-3.713Z"
      fill="url(#d)"
    />
    <path
      opacity=".2"
      d="m23.641 21.427-12.696 7.259a1.464 1.464 0 0 1-1.75 0l-.061.062.061.07a1.465 1.465 0 0 0 1.75 0l12.784-7.286-.088-.105Z"
      fill="#000"
    />
    <path
      opacity=".12"
      d="M9.122 28.636a1.767 1.767 0 0 1-.403-1.241v.132c-.026.447.118.888.403 1.232l.061-.062-.061-.061ZM28.006 18.938l-4.375 2.49.088.08 4.279-2.447a1.533 1.533 0 0 0 .875-1.267 1.667 1.667 0 0 1-.867 1.144Z"
      fill="#000"
    />
    <path
      opacity=".25"
      d="m10.942 6.9 17.063 9.75a1.654 1.654 0 0 1 .875 1.143 1.545 1.545 0 0 0-.875-1.267l-17.063-9.75C9.717 6.074 8.72 6.655 8.72 8.062v.132c0-1.407.997-1.988 2.222-1.293Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="a"
        x1="19.063"
        y1="7.86"
        x2="4.299"
        y2="22.543"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset=".01" stopColor="#00A1FF" />
        <stop offset=".26" stopColor="#00BEFF" />
        <stop offset=".51" stopColor="#00D2FF" />
        <stop offset=".76" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="29.602"
        y1="17.795"
        x2="8.427"
        y2="17.795"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset=".41" stopColor="#FFBD00" />
        <stop offset=".78" stopColor="orange" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="21.717"
        y1="19.817"
        x2="1.691"
        y2="39.723"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="6.378"
        y1=".352"
        x2="15.318"
        y2="9.242"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset=".07" stopColor="#2DA771" />
        <stop offset=".48" stopColor="#15CF74" />
        <stop offset=".8" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);
